import { defineMessages } from 'react-intl';

const translations = {
  message: {
    id: 'pages.packingView.pickFirstMessage.message',
    defaultMessage: 'This shipment should be picked first',
    description: 'Shipment pick first message',
  },
  actions: {
    pick: {
      id: 'actions.pick',
      defaultMessage: 'Pick',
      description: 'Label of the pick action of the pick first message',
    },
  },
};

export default defineMessages(translations);
